var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "withdraw",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.609,
    height: 17.609,
    viewBox: "0 0 17.609 17.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    "data-name": "Path 3010",
    d: "M16.607,13.945h-4.1a.614.614,0,1,1,0-1.229h4.1a1.025,1.025,0,0,0,1.024-1.024V3.5a1.025,1.025,0,0,0-1.024-1.024H3.5A1.025,1.025,0,0,0,2.479,3.5v8.19A1.025,1.025,0,0,0,3.5,12.716h6.552a.614.614,0,1,1,0,1.229H3.5A2.254,2.254,0,0,1,1.25,11.692V3.5A2.254,2.254,0,0,1,3.5,1.25h13.1A2.254,2.254,0,0,1,18.859,3.5v8.19a2.254,2.254,0,0,1-2.252,2.252Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#f5ca3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M11.325,21.939a.609.609,0,0,1-.434-.18L8.434,19.3a.614.614,0,0,1,.868-.868l2.023,2.022,2.023-2.022a.614.614,0,0,1,.868.868l-2.457,2.457A.609.609,0,0,1,11.325,21.939Z",
    transform: "translate(-2.52 -4.33)",
    fill: "#f5ca3d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M11.864,19.85a.614.614,0,0,1-.614-.614V11.864a.614.614,0,0,1,1.229,0v7.371A.614.614,0,0,1,11.864,19.85Z",
    transform: "translate(-3.06 -3.06)",
    fill: "#f5ca3d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    "data-name": "Path 3013",
    d: "M18.245,7.479H1.864a.614.614,0,1,1,0-1.229h16.38a.614.614,0,1,1,0,1.229Z",
    transform: "translate(-1.25 -2.155)",
    fill: "#f5ca3d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3014",
    "data-name": "Path 3014",
    d: "M7.321,10.979H4.864a.614.614,0,0,1,0-1.229H7.321a.614.614,0,1,1,0,1.229Z",
    transform: "translate(-1.793 -2.788)",
    fill: "#f5ca3d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3015",
    "data-name": "Path 3015",
    d: "M6.5,13.479H4.864a.614.614,0,0,1,0-1.229H6.5a.614.614,0,1,1,0,1.229Z",
    transform: "translate(-1.793 -3.241)",
    fill: "#f5ca3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawYellow);
export default __webpack_public_path__ + "static/media/withdraw-yellow.6fb9509c0f0cd9f22aafd3d2a3818de9.svg";
export { ForwardRef as ReactComponent };